import { transform, isEqual, isObject } from "lodash-es";
import { g, dia, ui, highlighters } from "@clientio/rappid";
import RappidContext from "../../rappid/rappid-context";

export function findViews(point: g.Point, paper: dia.Paper): dia.ElementView[] {
  const cellViewsBelow = paper.findViewsFromPoint(point);
  return cellViewsBelow.sort((a, b) => (a.model.isEmbeddedIn(b.model) ? -1 : 1));
}
export function findParent(cell: dia.Cell, paper: dia.Paper): dia.ElementView | undefined {
  let cellViewsBelow = findViews(cell.getBBox().center(), paper);
  cellViewsBelow = cellViewsBelow.filter((cellView) => cellView.model.get("embedable"));
  return cellViewsBelow.find((c) => c.model.id !== cell.id);
}
export function isParentCell(parent: dia.Cell | null, cell: dia.Cell): boolean {
  if (parent) {
    if (parent.id === cell.id) {
      return true;
    } else {
      if (parent.getParentCell()) {
        return isParentCell(parent.getParentCell(), cell);
      }
    }
  }
  return false;
}

export function difference<T>(object: T, base: T): T {
  function changes(object, base): T {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeStaticAttributes(result: any): any {
  delete result.marker;
  delete result.angle;
  delete result.embedable;
  delete result.linkable;
  delete result.fixedRatio;
  delete result.markup;
  delete result.attrs?.namebg;

  result.attrs = removeDisplay(result.attrs);

  return result;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function removeDisplay(attrs: any): any {
  if (attrs?.root?.display !== undefined) {
    delete attrs.root.display;

    if (Object.keys(attrs.root).length === 0) {
      delete attrs.root;
    }
  }

  return attrs;
}

export function deselectAll(context: RappidContext, cancelSelection = true) {
  ui.Halo.clear(context.paper);
  ui.FreeTransform.clear(context.paper);
  if (cancelSelection) {
    context.selection?.cancelSelection();
  }
}

export function moveEmbeddedRegionMarker(highlighter: highlighters.list) {
  if (highlighter.cellView.model.getParentCell()?.get("type") === "State") {
    highlighter.vel.attr("transform", `translate(-7, 12)`);
  }
}
